import authentication from "@/http/apis/personal/authentication";
import router from "@/router/index.js";
import { parseJWT } from "@/libs/common";
import { handlePersonalException } from "./utils"
import { usePersonalStore } from "@/store/personal";

export async function authenticateToken(token, proceedPayment = true) {
  let result = true;
  const personalStore = usePersonalStore();
  await authentication
    .getAuthenticate(token)
    .then(res => {
      if (res.status == 201) {
        result = false;
        personalStore.updatePersonalAppNo(res.data.formId);
        personalStore.updateUploadFlag(true);
        personalStore.updateStatusForPayment();
        if (proceedPayment) {
          router.push({ name: "StepPayment" });
        }
      }

      if (!personalStore.form.type) {
        let jwtObj = parseJWT(personalStore.jwt);
        let form = personalStore.form;
        form.type = jwtObj["app-type"];
        personalStore.updateForm(form);
      }
    })
    .catch(err => {
      result = false;
      handlePersonalException(err);
    });
  return result;
}